import { z } from 'zod';
import {
  NameFormValidation,
  PersonalInfoValidation,
  EmailValidation,
} from 'shared/validation/validationTemplates';

export const ProfileFormValidationSchema =
  NameFormValidation.and(EmailValidation).and(PersonalInfoValidation);

export type TProfileFormType = z.infer<typeof ProfileFormValidationSchema>;
